// keep the pointer field names in an object to lookup
const Pointer = {
  SkyObjectObservation: {
    telescope: "scopes",
    binoculars: "binoculars",
    camera: "cameras",
    eyepiece: "eyepieces",
    barlowReducer: "barlowsReducers",
  },
};

export default Pointer;
